module.exports = __webpack_public_path__ + "assets/img/img-placeholder-reel.9e735440.webp";